export default {
  LOG_OUT: 'log_out',
  CANCEL_IMPERSONATE: 'cancel_impersonate',
};
